(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.talentfunlTemplate_employerprofile = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard((typeof window !== "undefined" ? window['React'] : typeof global !== "undefined" ? global['React'] : null));

var ReactDOM = _interopRequireWildcard((typeof window !== "undefined" ? window['ReactDOM'] : typeof global !== "undefined" ? global['ReactDOM'] : null));

var _ = _interopRequireWildcard((typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null));

var _talentfunlSearchkit = _interopRequireDefault((typeof window !== "undefined" ? window['talentfunlSearchkit'] : typeof global !== "undefined" ? global['talentfunlSearchkit'] : null));

var talentfunl = _interopRequireWildcard((typeof window !== "undefined" ? window['talentfunlUtils'] : typeof global !== "undefined" ? global['talentfunlUtils'] : null));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var talentfunlTemplate_employerprofile =
/*#__PURE__*/
function (_React$Component) {
  _inherits(talentfunlTemplate_employerprofile, _React$Component);

  function talentfunlTemplate_employerprofile(props) {
    _classCallCheck(this, talentfunlTemplate_employerprofile);

    return _possibleConstructorReturn(this, _getPrototypeOf(talentfunlTemplate_employerprofile).call(this, props));
  }

  _createClass(talentfunlTemplate_employerprofile, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return React.createElement("div", {
        className: props.bemBlocks.item().mix(props.bemBlocks.container("item"))
      }, React.createElement("a", {
        href: talentfunl.getItemUrl(props.result._source, 'employerprofile')
      }, React.createElement("div", {
        className: 'image-wrapper'
      }, props.result._source.profileLogoThumbnail && React.createElement("img", {
        src: props.result._source.profileLogoThumbnail,
        alt: props.result._source.employerName
      })), React.createElement("h3", {
        className: props.bemBlocks.item("employerName"),
        dangerouslySetInnerHTML: {
          __html: _.get(props.result, "highlight.employerName", false) || props.result._source.employerName
        }
      })));
    }
  }]);

  return talentfunlTemplate_employerprofile;
}(React.Component);

var _default = talentfunlTemplate_employerprofile;
exports.default = _default;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}]},{},[1])(1)
});
